import { render, staticRenderFns } from "./DeleteSuccess.vue?vue&type=template&id=597775b6&scoped=true&"
import script from "./DeleteSuccess.vue?vue&type=script&lang=js&"
export * from "./DeleteSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DeleteSuccess.vue?vue&type=style&index=0&id=597775b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597775b6",
  null
  
)

export default component.exports